module.exports = __webpack_public_path__ + "static/media/prompt_close_icon.fab48607.svg";